import {buildProjectApiUrl} from "api/configuration";
import {http} from "api/http";

export const getGeoZoneData = (codes: string[]): Promise<Map<String, number[][][]>> => {
    return http.get(
        buildProjectApiUrl(`/geozones/geodata?codes=${codes.join(",")}`),
        "Une erreur est survenue"
    );
};
